<template>
  <transition mode="out-in">
    <router-view v-if="isLoadKeiyaku && isLoadedCss && isLoadJs"/>
  </transition>
</template>

<script>
import base64Url from 'base64-url'
import { loadAllCss } from '../utils/loadCss'
import template_styles from '../constant/template_styles'
import { loadScript } from '../utils/loadScript'

import {
  GET_KEIYAKU_BY_DOCUMENT_ID,
  RESET_KEIYAKU_STATE,
  SAVE_MUSUBELL_DOCUMENT_ID,
  GET_MUSUBELL_DOCUMENT_FILE_INFO
} from '@/store/modules/keiyaku/actions'

export default {
  name: 'DocumentMain',
  data() {
    return {
      isLoadKeiyaku: false,
      isLoadedCss: false,
      isLoadJs: false
    }
  },
  created () {
    loadAllCss(template_styles).then(() => {
      this.isLoadedCss = true
    })

    loadScript(`${process.env.VUE_APP_BASE_URL}/js/pdf-separation.js`).then(() => {
      this.isLoadJs = true
    })

    const musubellDocumentGlobalIdBase64 = this.$route.params.documentGlobalId
    const musubellDocumentGlobalId = base64Url.decode(musubellDocumentGlobalIdBase64)
    const musubellDocumentId = musubellDocumentGlobalId.split(':')[1]
    this.loadKeiYaku(musubellDocumentId)
  },
  methods: {
    loadKeiYaku(loadDocumentId) {
      const { documentGlobalId } = this.$route.params
      this.isLoadKeiyaku = false
      const mainDocumentIdDecode = base64Url.decode(documentGlobalId)
      const mainDocumentId = mainDocumentIdDecode.split(':')[1]
      this.$store.dispatch(RESET_KEIYAKU_STATE)
        .then(() => this.$store.dispatch(GET_KEIYAKU_BY_DOCUMENT_ID, loadDocumentId))
        .then(() => this.$store.dispatch(GET_MUSUBELL_DOCUMENT_FILE_INFO, loadDocumentId))
        .then(() => this.$store.dispatch(SAVE_MUSUBELL_DOCUMENT_ID, mainDocumentId))
        .catch((error) => {
          const messageErrorCode = error.data.error.code
          if(messageErrorCode === 'UNAUTHORIZED') {
            this.$router.push('/pages/not-authorized')
          }
        })
        .finally(() => {
          this.isLoadKeiyaku = true
        })
    }
  },
  watch: {
    '$route.params.documentGlobalId' () {
      const musubellDocumentGlobalIdBase64 = this.$route.params.documentGlobalId
      const musubellDocumentGlobalId = base64Url.decode(musubellDocumentGlobalIdBase64)
      const musubellDocumentId = musubellDocumentGlobalId.split(':')[1]
      this.loadKeiYaku(musubellDocumentId)
    },
    '$route.params': {
      deep: true,
      handler(params) {
        if (params.copyDocumentGlobalId) {
          const musubellDocumentGlobalIdBase64 = params.copyDocumentGlobalId
          const musubellDocumentGlobalId = base64Url.decode(musubellDocumentGlobalIdBase64)
          const musubellDocumentId = musubellDocumentGlobalId.split(':')[1]
          this.loadKeiYaku(musubellDocumentId)
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
